import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Template } from 'devextreme-react/core/template';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DateBox from 'devextreme-react/date-box';
import { locale } from 'devextreme/localization';
import ChatsService from '../../controllers/ChatController';

class HistoryFilters extends Component {

    constructor(props) {
        super(props)
        locale(navigator.language);
        this.state = {
            search: "",
            loading: false,
            caller: "",
            channel: "",
            startDate: new Date(),
            endDate: new Date(),
            channels: [
                "all2",
                "fidelity",
                "facebook",
                "instagram",
                "rainbow",
                "sms",
                "telegram",
                "twitter",
                "whatsapp",
                "mail"
            ]
        }
        this.setSearch = this.setSearch.bind(this);
        this.search = this.search.bind(this);
        this.setCaller = this.setCaller.bind(this);
        this.changeChannel = this.changeChannel.bind(this);
        this.startDateChange = this.startDateChange.bind(this);
        this.endDateChange = this.endDateChange.bind(this);
        this.templateRender = this.templateRender.bind(this);
    }

    setSearch(e) {
        e.preventDefault();
        this.setState({
            search: e.target.value
        });
    }

    setCaller(e) {
        e.preventDefault();
        this.setState({
            caller: e.target.value
        });
    }

    changeChannel(e) {
        e.preventDefault();
        this.setState({
            channel: e.target.value === "all2" ? "" : e.target.value
        });
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    startDateChange(e) {

        this.setState({
            startDate: e.value
        });

        if (e.value > this.state.endDate) {
            this.setState({
                endDate: e.value
            });
        }
    }

    endDateChange(e) {
        this.setState({
            endDate: e.value
        });
    }

    search = e => {
        this.setLoading(true);
        let user = JSON.parse(localStorage.getItem("fc-logged"));

        this.state.startDate.setHours(0);
        this.state.startDate.setMinutes(0);
        this.state.startDate.setSeconds(0);
        this.state.startDate.setMilliseconds(0);

        this.state.endDate.setHours(23);
        this.state.endDate.setMinutes(59);
        this.state.endDate.setSeconds(59);
        this.state.endDate.setMilliseconds(997);

        ChatsService.search(
            null,
            this.state.search,
            this.state.caller,
            this.state.channel,
            this.state.startDate,
            this.state.endDate,
            user.userId,
            result => {
                console.log(result);
                this.setLoading(false);
                var interaction = [];
                if (result && result.data.length > 0) {
                    result.data.forEach((v, i) => {
                        let channel = v.type.toLowerCase();
                        interaction.push({
                            conversationId: v.type === "MAIL" ? v.conversationId : v.id,
                            id: v.id,
                            name: v.name || v.fullname,
                            type: v.type,
                            lastMessage: "",
                            messages: v.messages,
                            unreadMessages: 0,
                            channel: channel === "all2" ? "none" : channel,
                            date: v.date,
                            agent: v.agent,
                            group: v.group,
                            phone: v.phone,
                            email: v.email,
                            userId: v.pin,
                            pin: v.pin,
                            image: v.image,
                            interactionType: "chat",
                            guid: v.guid,
                            groupId: v.groupId,
                            language: "",
                            from: v.from,
                            to: v.to,
                            tenantId: v.tenantId,
                            openable: v.openable,
                            emailId: v.emailId,
                            bookId: v.bookId,
                            outbound: v.outbound
                        })
                    });
                }
                this.props.toggleModal();
                this.props.setInteractions(interaction)
            }
        );
    }

    templateRender() {
        return <FontAwesomeIcon icon={duotone("calendar-day")} />
    }

    render() {
        return (<><Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
            <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                <Modal.Header>
                    <Modal.Title><FontAwesomeIcon icon={duotone("filters")} /> {this.props.t("filters")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-4" controlId="fcHistoryCaller">
                                    <Form.Label>{this.props.t("interlocutor")}</Form.Label>
                                    <Form.Control type="text" value={this.state.caller} onChange={this.setCaller} />
                                    <Form.Text className="text-muted">
                                    </Form.Text>
                                </Form.Group>
                                <Form.Group className="mb-4" controlId="fcHistorySearch">
                                    <Form.Label>{this.props.t("search")}</Form.Label>
                                    <Form.Control type="text" value={this.state.search} onChange={this.setSearch} />
                                    <Form.Text className="text-muted">
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-4" controlId="fcHistoryChannel">
                                    <Form.Label>{this.props.t("channel")}</Form.Label>
                                    <Form.Select onChange={this.changeChannel} value={this.state.channel}>
                                        {
                                            this.state.channels.map(elem => {
                                                return <option key={elem} value={elem}> {this.props.t(elem)}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group controlId="fcStartDate">
                                    <Row>
                                        <Col>
                                            <Form.Label>{this.props.t("startdate")}</Form.Label>
                                            <DateBox
                                                value={this.state.startDate}
                                                type="date"
                                                onValueChanged={this.startDateChange}
                                                dropDownButtonTemplate='conditionalIcon'
                                                openOnFieldClick={true}
                                            >
                                                <Template name='conditionalIcon' render={this.templateRender} />
                                            </DateBox>
                                        </Col>
                                        <Col>
                                            <Form.Label>{this.props.t("enddate")}</Form.Label>
                                            <DateBox
                                                value={this.state.endDate}
                                                type="date"
                                                onValueChanged={this.endDateChange}
                                                dropDownButtonTemplate='conditionalIcon'
                                                openOnFieldClick={true}
                                            >
                                                <Template name='conditionalIcon' render={this.templateRender} />
                                            </DateBox>
                                        </Col>
                                    </Row>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.search}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal>
        </>)
    }
}

export default withTranslation()(HistoryFilters);